import { RootState } from '../redux/root-state';

export const isVideoOverlayOpened = (state: RootState) =>
  state.fullScreenModal.lightbox;
